import { render } from "./display-options-modal.vue?vue&type=template&id=4b22d438"
import script from "./display-options-modal.vue?vue&type=script&lang=js"
export * from "./display-options-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__